var _style, _ellipse, _ellipse2, _path, _path2, _path3, _defs, _defs2, _defs3, _path4, _path5, _defs4, _path6, _defs5, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeakingOwl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "991.8px",
    height: "949.7px",
    viewBox: "0 0 991.8 949.7",
    style: {
      enableBackground: "new 0 0 991.8 949.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#F53E1E;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:8;stroke-miterlimit:10;}\r\n\t.st2{clip-path:url(#SVGID_2_);}\r\n\t.st3{clip-path:url(#SVGID_4_);}\r\n\t.st4{clip-path:url(#SVGID_6_);fill:none;stroke:#000000;stroke-width:8;stroke-miterlimit:10;}\r\n\t.st5{opacity:0.9686;clip-path:url(#SVGID_6_);enable-background:new    ;}\r\n\t.st6{clip-path:url(#SVGID_8_);fill:none;stroke:#000000;stroke-width:8;stroke-miterlimit:10;}\r\n\t.st7{clip-path:url(#SVGID_10_);fill:none;stroke:#000000;stroke-width:8;stroke-miterlimit:10;}\r\n\t.st8{display:none;fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st9{display:none;fill:none;stroke:#F53E1E;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st10{fill:none;stroke:#000000;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 647.2,
    cy: 404.3,
    rx: 112.1,
    ry: 103
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 338.4,
    cy: 404,
    rx: 112.1,
    ry: 103
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M757.6,386.5c16.6-16.3,33.1-32.6,49.7-48.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M227.7,377c-22.3-12.3-44.7-24.6-67-36.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M450.5,416.7c1.5-13.6,20.9-25.3,42.1-25.5c21.1-0.1,40.9,11.3,42.9,24.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 130.8,
    width: 726,
    height: 754
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 130.8,
    width: 726,
    height: 754
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 130.8,
    width: 726,
    height: 754
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M733.7,244.7c81.9,49.1,79.2,113.5,79.2,154.9c0,186.1-152.2,294.6-333.6,294.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M479.3,694.2c-181.6,0-342.7-132.3-328.8-294.1c3.9-45.4,2.3-108.4,87.1-158.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 187.2,
    y: 57.4,
    width: 154.4,
    height: 187.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M338.9,131.6c-29.2-27.3-60.5-49.6-97.4-64.5c-12.9-5.6-27.7-9.3-38.8,0c-5.5,5.6-11.1,13-11.1,20.4 c-1.9,44.6,3.2,80,21.6,119c7.4,13,16.6,34,26.4,34"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 621.9,
    y: 47.4,
    width: 198.9,
    height: 200.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M729.7,244.7c24.3-12.9,57.5-27.7,63.1-56.6c-15.7,3.8-26.3,4.1-42.1,7.3c26.1-16.6,48.7-39.5,62.1-67.7 c-12.7,5-24.8,11.4-37.5,16.5c10.7-27.6,18.1-61-0.4-87c-9.2-9.3-22.2-5.6-33.2-1.9c-44.3,22.3-81.2,55.7-117.1,89.1"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M640,130.1c-5.4,3.7-7.6,11.6-13.7,14c-2.6,1-5.5,0.8-8.2,0.4c-25.5-3.4-47.9-18.2-70.2-31.1 c-22.3-12.9-47.4-24.6-71.3-18.4c30,6.1,57,25.3,70.9,52.5c-28.2-18.5-62-27.4-95.6-29c-33.6-1.6-61.4,5.6-94,14.3 c-7.1,1.9-16,3.4-20.5-2.4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M752.7,96.8c21.9-9.6-13.9,4.7-21.9,16c-9.4,13.2-42.6,50.3-45.3,66.4c-0.8,4.5-1.4,9.2-3.8,13.2 c-5.1,8.5-16.3,10.5-26.1,11c-35.7,1.7-71.3-5.9-107.1-5.5c-7.5,0.1-15.4,0.6-21.6,4.8c-10.2,6.8-14.2,21.9-26,25.3 c-12.9,3.7-23.9-9-33.7-18.1c-15.5-14.4-36.1-22.5-57-25.1c-20.9-2.7-42.2-0.2-62.9,4.2c-11.6,2.5-23.3,5.7-35.2,4.8 c-2.7-0.2-5.6-0.7-7.7-2.4c-2.4-1.9-3.4-4.9-4.4-7.8c-8.5-24.5-20.8-47.6-36.4-68.2c-3.9-5.1-19.7-16.8-25.9-18.5 c-19-5,22.5,6.6,25.4,18.5"
  })))))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M600.8,554c-70.4-25.7-154.3-25-233-3.2c16.4,62.5,65,108,115.6,108c50.5,0,99.2-45.4,115.6-107.9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M149.2,395.9c-0.8,2.8-1.7,5.6-2.5,8.4c-4.9-2.2-8.3-7.2-8.3-12.2c0-19.9-0.1-39.9-0.1-59.8 c7.9,0,15.8,0,22.9,1.3c1.3,0.5,2.7,1,4,1.5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M811.9,399.5c0.4,2.9,0.9,5.8,1.3,8.7c5.4-1.4,9.5-5.9,10.3-10.9c3-19.7,6-39.4,9-59.2 c-8.1-1.2-16.2-2.3-23.6-2.1c-1.5,0.3-2.9,0.6-4.3,0.9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M730,602.5c63.7,9.9,118.4,31.1,149.6,58c31.3,26.9,38.8,59.3,20.6,88.6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.4,724.5c-6.7-25.5,11.3-51.7,50.3-73.3s98.6-38.3,165.8-47.2c6.2-0.5,12.4-1,18.5-1.6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M754.1,825.9c-12.3-35.5-35.8-62.7-63.9-83.8c-41-30.9-87.5-30-133.1-12.5c-37.8,14.5-66.9,42.6-91.8,75.4 c-3.8,5-8.8,11.6-3.5,19.2c6,8.6,13.5,1.8,18.1-0.5c10.3-5.3,19.4-13.2,28.6-20.7c5.9-4.8,11.9-4.8,18.5-3.4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M431.6,832.9c5.7-4.7,5.1-9.8,1.7-15.9c-22-40.2-51.8-72.2-92.1-91c-42.4-19.8-80.4-5.4-115,22.7 c-4.5,3.6-10.9,6.4-11.9,13.8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M722.3,827.6c-12.3,0-24.6,1.2-36.7-0.2c-29.8-3.5-54.6,9.4-78.4,25.1c-8.3,5.5-16.8,10.5-25.2,15.7 c-9.7,6-17.7,6.5-23.4-5.4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M647.2,776.7c-1.1,2.9-1.5,7.5-3.5,8.5c-38.1,19.1-63.9,53.2-93.4,82.9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M612.1,771.4c-22.8,12.1-41.9,29.5-58.1,49.6c-10.3,12.7-21.4,24.4-32.1,36.6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M314.7,776.7c28.5,24.1,48,55.7,66.8,87.9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M294.7,794.2c21.8,19.6,39.5,43,56.8,66.8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M588.7,753.8c-44.6,20.3-71.7,57.1-88.5,103.7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M430,832.9c-33.2-24.5-64.8-51.3-96.9-77.4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M384.9,806.5c-0.5,18.2,13.7,30.6,16.7,47.5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M272.9,815.3c15,15.2,30.1,30.5,45.1,45.7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M598.7,280.5c15.3-26.6,44-42.8,70.5-39.6s49.2,25.6,55.7,54.8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.2,291.8c9.2-26.9,32.4-46,57.2-47.2s50.2,15.4,62.7,41.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeakingOwl);
export default __webpack_public_path__ + "static/media/peakingOwl.01635306556c48ffbeb40ab9db9c350a.svg";
export { ForwardRef as ReactComponent };